import React, { useState, useEffect } from 'react';
import { useRecordContext } from 'react-admin';

interface CoverImageFieldProps {
  source: string;
  label?: string;
}

export const CoverImageField = ({ source, label }: CoverImageFieldProps) => {
  const record = useRecordContext();
  const [coverUrl, setCoverUrl] = useState<string | null>(null);

  useEffect(() => {
    if (record && record.cover_image_url) {
      setCoverUrl(record.cover_image_url);
    } else if (record && record.cover_image_key) {
      // If we have S3 key but no URL, we could generate presigned URL here
      // For now, just show that cover exists
      setCoverUrl(null);
    }
  }, [record]);

  if (!coverUrl) {
    return <span>No cover image</span>;
  }

  return (
    <div>
      <img 
        src={coverUrl} 
        alt="Cover" 
        style={{ 
          width: '200px', 
          height: '200px', 
          objectFit: 'cover', 
          borderRadius: '8px',
          border: '1px solid #ddd'
        }} 
      />
    </div>
  );
};

